<template>
    <md-snackbar :md-duration="duration" :md-active.sync="snackBarVisible">
      <span>{{snackBarMessage}}</span>
      <md-button class="md-info md-simple" @click="snackBarVisible = false">Close</md-button>
    </md-snackbar>
</template>

<script>

export default {
  name: "snack-bar",
  data() {
    return {
      snackBarMessage: "",
      snackBarVisible: false,
      duration: 5000
    };
  },
  methods: {
      notify(msg) {
      this.snackBarMessage = msg;
      this.snackBarVisible = true;
    }
  }
};
</script>